export const removeAccents = (s: string): any => {
  const i = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖŐòóôõöőÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜŰùúûüűÑñŠšŸÿýŽž'.split(''),
    o = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUUuuuuuNnSsYyyZz'.split('');
  let map: any = {};
  i.forEach((i, idx) => (map[i] = o[idx]));
  return s.replace(/[^A-Za-z0-9]/g, function (ch) {
    return map[ch] || ch;
  });
};
